var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{attrs:{"label":"Pzncheck","refresh":this.refresh,"table":"pzncheck","initialSortBy":"pharmacy","initialSortDesc":true,"hideNewAndEdit":true,"hideDelete":true,"hideExport":true},on:{"childMessage":_vm.onMessageFromListReceived}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }